var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24L8 21.2L1.8 23.6C1.35556 23.7778 0.944445 23.7278 0.566667 23.45C0.188889 23.1722 0 22.8 0 22.3333V3.66667C0 3.37778 0.0833333 3.12222 0.25 2.9C0.416667 2.67778 0.644444 2.51111 0.933333 2.4L8 0L16 2.8L22.2 0.4C22.6444 0.222222 23.0556 0.272222 23.4333 0.55C23.8111 0.827778 24 1.2 24 1.66667V20.3333C24 20.6222 23.9167 20.8778 23.75 21.1C23.5833 21.3222 23.3556 21.4889 23.0667 21.6L16 24ZM14.6667 20.7333V5.13333L9.33333 3.26667V18.8667L14.6667 20.7333ZM17.3333 20.7333L21.3333 19.4V3.6L17.3333 5.13333V20.7333ZM2.66667 20.4L6.66667 18.8667V3.26667L2.66667 4.6V20.4Z",
    fill: "#138776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e0783b54509e4c9e4aa2257b83b75a17.svg";
export { ForwardRef as ReactComponent };